import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Shift } from '@/openapi';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useUpdateShiftMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (shift: Shift) => {
      return ScheduleConfigService.scheduleConfigServiceUpdateShift({
        path: { shiftId: shift.id },
        body: shift,
      });
    },
    onSettled: async (_data, _error) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.shifts.list() }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
      ]);
    },
  });
};
